import { FC } from "react";
import {
  ROW_SUBTITLE_STYLES,
  ROW_TITLE_FONT_STYLES,
  ROW_TITLE_STYLES,
} from "../../detailedPages/styles";
import { capitalizeAssociatedPress } from "../../../../helpers/string/capitalize";
import { Styled } from "../../types";

export const LabelAtom: FC<
  React.PropsWithChildren<
    {
      title: string;
      htmlFor: string;
      subtitle?: string;
      srOnly?: boolean;
      narrowInput?: boolean;
      capitalize?: boolean;
      tooltip?: string;
    } & Styled
  >
> = ({
  title,
  htmlFor,
  subtitle,
  srOnly,
  narrowInput,
  capitalize = true,
  tooltip,
  children,
  className,
}) => (
  <label
    htmlFor={htmlFor}
    className={`${className ?? (srOnly ? "sr-only" : narrowInput ? ROW_TITLE_FONT_STYLES : ROW_TITLE_STYLES)} cursor-pointer has-disabled:cursor-not-allowed`}
    title={tooltip}
  >
    {children}
    <span className={srOnly ? "sr-only" : ""}>
      {capitalize ? capitalizeAssociatedPress(title) : title}
    </span>
    {!!subtitle?.length && <p className={ROW_SUBTITLE_STYLES}>{subtitle}</p>}
  </label>
);
